import api from 'config/Api/Api';
import { formatFormDataBody } from 'utils';

const baseEndpoint = 'v1/list-phone-numbers';

export default {
  getListPhoneNumbers( params ) {
    return api.get( baseEndpoint, params );
  },

  getListPhoneNumber( id, params ) {
    return api.get( `${baseEndpoint}/${id}`, params );
  },

  deleteListPhoneNumbers( id ) {
    return api.delete( `${baseEndpoint}/${id}` );
  },

  exportListPhoneNumbers( data ) {
    return api.post( `${baseEndpoint}/export-csv`, data );
  },

  saveListPhoneNumbers( data ) {
    return api.post( baseEndpoint, formatFormDataBody( data ) );
  },

  exportFavorite( id ) {
    return api.get( `v1/media-audio/${id}/download` );
  },
};
